import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';
export const FadeinAnimation: AnimationTriggerMetadata = trigger('fadein', [
  transition('void => *', [
    style({ opacity: 0 }),
    animate(300, style({ opacity: 1 })),
  ]),
]);
